export default $(document).ready((e) => {

  if ($('.page.edit-investor').length == 0) return;

  // init submit button
  $('a.submit').click((e) => {
    $('form').submit();
  })

});